<template>
  <v-dialog v-model="dialog" width="800" :persistent="true" @keydown="saveIfPossible($event)">
    <template v-slot:activator="{ on }">
      <permission-button color="primary" :button-class="`ml-0 mr-0`" @click="open()"
                         :permission="`admin_product_categories`"
                         :tooltip="{right: true, bottom: false, attach: false}"
      >
        {{ 'app.product_category.add_category' | trans }}
      </permission-button>
    </template>
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md no-padding>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                    :label="'app.name' | trans"
                    clearable
                    v-model="data.name"
                    :rules="rules.name"
                    full
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="save()" :disabled="!valid" :loading="loading" ref="saveButton">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RulesBuilder from "../../../utils/rulesBuilder";
import {trans} from "../../../app";
import {mapActions, mapGetters} from "vuex";

export default {
  data: function () {
    return {
      dialog: false,
      loading: false,
      valid: false,
      rulesBuilder: null,
      data: {
        id: null,
        name: '',
        parentId: null,
      },
    };
  },
  created() {
    this.rulesBuilder = new RulesBuilder();
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.setEditMode(false);
      this.setProductCategoryToEdit(null);
      this.setParentId(null);
      this.$refs.form.reset();
    },
    async save() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      this.loading = true;
      try {
        if (!!this.data.id) {
          await this.updateCategory({
            id: this.data.id,
            name: this.data.name,
          });
          this.$toast.success(trans('app.actions.edited', {name: trans('app.product_category.category')}))
        } else {
          await this.saveCategory({
            name: this.data.name,
            parentId: this.parentId,
          });
          this.$toast.success(trans('app.actions.added', {name: trans('app.product_category.category')}));
        }
      } catch (e) {
        this.$toast.error(trans('app.error_occurred'));
        this.sentryCaptureException(e);
      }
      await this.fetchProductCategories();
      this.loading = false;
      this.close();
    },
    saveIfPossible(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        this.save();
      }
    },
    ...mapActions(['fetchProductCategories', 'saveCategory', 'setEditMode', 'updateCategory', 'setProductCategoryToEdit', 'setParentId']),
  },
  computed: {
    ...mapGetters(['editMode', 'productCategoryToEdit', 'parentId']),
    rules: function () {
      return {
        name: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.name'))
              .addMinLengthRule(trans('app.name'), 2)
              .getRules(),
        ],
      };
    },
    title() {
      if (this.data.id === null || this.data.parentId !== null) {
        return trans('app.add');
      }
      return trans('app.edit');
    },
  },
  watch: {
    productCategoryToEdit(val) {
      if (val !== null) {
        this.data.id = val.id;
        this.data.name = val.name;
      } else {
        this.data.id = null;
        this.data.name = '';
      }
    },
    editMode() {
      this.dialog = this.editMode;
    },
    parentId(val) {
      this.data.parentId = val;
      if (val !== null) {
        this.open();
      }
    },
  },
}
</script>

<style scoped>

</style>
